export default "assets/images/icons/calendar-6668a112.svg";